import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteApplication } from 'modules/ats/hooks/applications/useDeleteApplication'

interface DeleteJobModalProps {
  id: number
  onCancel: () => void
  onSuccess: () => void
}

const DeleteApplicationConfirmModalComponent = ({
  id,
  onCancel,
  onSuccess,
}: DeleteJobModalProps) => {
  const { deleteApplication, loading: deleting } = useDeleteApplication()

  const onDelete = async () => {
    const response = await deleteApplication({ id })

    const result = handleResult(response, () => undefined)

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })

      onSuccess()
    }
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('ats.application_details.confirm_delete.title')}
      description={i18n.t('ats.application_details.confirm_delete.description')}
      onClose={onCancel}
      onSubmit={onDelete}
      footer={
        <Box flexDirection="row" justifyContent="flexEnd" gap="s8">
          <Button type="secondary" disabled={deleting} onClick={onCancel}>
            {i18n.t('common.cancel')}
          </Button>

          <Button type="negative" disabled={deleting} submit>
            {i18n.t('common.delete')}
          </Button>
        </Box>
      }
    />
  )
}

export const DeleteApplicationConfirmModal = observer(DeleteApplicationConfirmModalComponent)
